import { render, staticRenderFns } from "./AliPayDesc.vue?vue&type=template&id=6b6e649a&scoped=true&"
var script = {}
import style0 from "./AliPayDesc.vue?vue&type=style&index=0&id=6b6e649a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e649a",
  null
  
)

export default component.exports